import { createCheckoutSession, getCurrentUserSubscriptions, getStripePayments, Price, Product, Subscription } from '@invertase/firestore-stripe-payments';
import { getApp } from 'firebase/app';
import { doc, getDoc } from 'firebase/firestore';
import { StartPremiumTrialResponse } from '../models/DTO';
import { WorkspaceTier } from '../models/local/Types';
import { FireClient, getFunc } from './FireClient';

export class FireClientPayment {
  constructor(private client: FireClient) {
  }

  async moveToCheckoutPage(priceId: string, workspaceId: string, workspaceName: string, userId: string) {
    const session = await createCheckoutSession(this.getPayments(),
      { price: priceId, metadata: { workspaceId, workspaceName, userId } }
    );
    window.location.assign(session.url);
  }

  async getUserSubscriptions(workspaceId: string): Promise<Subscription[]> {
    const payments = this.getPayments();
    let subs = await getCurrentUserSubscriptions(payments, { status: ['active', 'trialing', 'past_due', 'unpaid'] });
    return subs.filter(s => s.metadata['workspaceId'] === workspaceId);
  }

  async getProduct(productId: string): Promise<Product | undefined> {
    const d = (await getDoc(doc(this.client.store, "s_products", productId)));
    return d.data() as Product | undefined;
  }

  async getPrice(productId: string, priceId: string): Promise<Price | undefined> {
    const d = (await getDoc(doc(this.client.store, "s_products", productId, 'prices', priceId)));
    return d.data() as Price | undefined;
  }

  async manageSubscription() {
    let func = getFunc('ext-firestore-stripe-payments-createPortalLink');
    const { data }: any = await func({ returnUrl: window.location.href });
    window.location.assign(data.url);
  }

  getPayments() {
    return getStripePayments(this.client.app, {
      productsCollection: "s_products",
      customersCollection: "s_customers",
    });
  }

  async startPremiumTrial(workspaceId: string): Promise<StartPremiumTrialResponse> {
    let func = getFunc('startPremiumTrial');
    const res = await func({ workspaceId });
    return res.data as StartPremiumTrialResponse;
  }
}